import React, { Component } from 'react';

class AddUSSDString extends React.Component {

    submit() {
        return null;
    }

    render() {
        return (null);
    }
}

export default AddUSSDString;